
import { defineComponent } from "vue";
import meetlookup from "../MeetLookup";
import PullRefresh from "pull-refresh-vue3";

export default defineComponent({
  components: {
    PullRefresh,
  },
  mixins: [meetlookup],
  props: {},
  data: function () {
    return {
      liveSupported: false,
      synchedAthletes: 0,
      isloading: false,
      pictureIndex: 0,
      imgError: false,
    };
  },
  methods: {
    get_landing_page_from_status(status) {
      if (status == 5) {
        return "Results";
      }
      if (status == 2) {
        return "Heats";
      }
      if (status == 3) {
        return "Results";
      }
      return "Entries";
    },
    get_synchronized_athletes() {
      let tmp = 0;
      if (this.athletes) {
        for (let i = 0; i < this.athletes.length; i++) {
          if ("swrid" in this.athletes[i]) {
            tmp = tmp + 1;
          }
        }
      }
      return tmp;
    },
    onRefresh() {
      this.$gtag.event("live", {
        event_category: "live_pageload",
        event_label: "live_meet",
      });
      this.isloading = true;
      this.update_meet();
      this.isloading = false;
    },
    onImgError() {
      this.imgError = true;
    },
  },
  updated() {
    if (this.main) {
      localStorage.nation = this.main.nation;
      localStorage.meetid = this.main.id;
    }
  },
  created() {
    this.pictureIndex = Math.floor(Math.random() * 4);
    this.$gtag.event("live", {
      event_category: "live_pageload",
      event_label: "live_meet",
    });
    {
      this.$store.dispatch("setMain", this.$route.params.meetid);
      this.$store.dispatch("setAthletes", this.$route.params.meetid);
      this.$store.dispatch("setEvents", this.$route.params.meetid);
      this.$store.dispatch("setEventsBySession", this.$route.params.meetid);
      this.$store.dispatch("setAgegroups", this.$route.params.meetid);
      this.$store.dispatch("setClubs", this.$route.params.meetid);
    }
  },
  computed: {
    filename() {
      if (this.imgError) {
        return this.get_meet_image_src(this.pictureIndex);
      } else {
        let url =
          "https://live.swimrankings.net/meets/" +
          this.$route.params.meetid +
          "/main.png";
        return url;
      }
    },
  },
});
